import { Wrapper } from '@/modules/landings/protection/components/TrackingNumber'
import { ProtectionDTO } from '@bookips/solvook-api-shared'
import { Table } from 'antd'
import type { ColumnsType } from 'antd/lib/table'
import dayjs from 'dayjs'
import React from 'react'

export interface CertificateDataType extends ProtectionDTO {
	// ProtectionDTO	r_number: string
	// 	book_name: string
	// 	name: string
	// 	expired_at: Date
	// 	bid?: number
	//
	// 	certificate_number?: string
	//
	// 	id?: string
	// 	identify_number?: string
	// 	is_expired?: boolean
	// 	is_mail_sent: boolean
	//
	// 	options?: object
	// 	payment_date?: Date
	// 	price_option?: string
	// 	publisher?: string
	// 	uid?: String
}
export interface TrackingResultProps {
	r_number: string
	book_name: string
	name: string
	expired_at: Date
}

export const TrackingResult: React.FC<{ data: CertificateDataType[] }> = ({ data }) => {
	const expiredAt = dayjs(data[0]?.expired_at)?.format('YYYY.MM.DD')
	const columns: ColumnsType<CertificateDataType> = [
		{
			title: 'R인증 번호',
			dataIndex: 'r_number',
			key: 'r_number',
		},
		{
			title: '수업자료명',
			dataIndex: 'book_name',
			key: 'book_name',
		},
		{
			title: '저작자명',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: '만료일',
			key: 'expired_at',
			dataIndex: 'expired_at',
			render: (date: Date) => {
				return (
					<div style={{ color: data[0].is_expired && 'red' }}>
						{data[0].is_expired ? `${expiredAt}만료됨` : expiredAt}
					</div>
				)
			},
		},
	]

	return (
		<Wrapper>
			<p className={'title'}>조회결과</p>
			<Table
				columns={columns}
				dataSource={data}
				locale={{ emptyText: '조회된 결과가 없습니다.' }}
				pagination={false}
			/>
		</Wrapper>
	)
}
